import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.Originators.form.titleCreate')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.formValid
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.saveAndCreate')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, _vm._l(Object.keys(_vm.dataSourcesData), function (curType) {
    return _c(VCol, {
      key: `type_${curType}`,
      staticClass: "px-2",
      attrs: {
        "cols": "6",
        "md": "4",
        "lg": "3"
      }
    }, [_c(VHover, {
      attrs: {
        "open-delay": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function ({
          hover
        }) {
          return [_c(VCard, {
            staticClass: "pa-3 mx-0",
            style: `height: 260px; cursor: pointer; border: 1px solid ${_vm.borderColor};`,
            attrs: {
              "elevation": hover ? 6 : 2
            },
            on: {
              "click": function ($event) {
                return _vm.selectedType(curType);
              }
            }
          }, [_c('div', {
            staticStyle: {
              "display": "block",
              "margin": "0 auto",
              "width": "129px",
              "height": "129px"
            }
          }, [_c('img', {
            staticStyle: {
              "display": "block",
              "margin": "0 auto",
              "padding": "4px",
              "width": "125px",
              "height": "125px",
              "object-fit": "contain",
              "background-color": "white",
              "border-radius": "4px"
            },
            attrs: {
              "src": `img/niota-classic/datasources/${_vm.dataSourcesData[curType].image}`
            }
          })]), _c('h4', {
            staticClass: "ma-0 pa-0"
          }, [_vm._v(_vm._s(_vm.dataSourcesData[curType].name || curType))]), _vm._v("\n              " + _vm._s(_vm.$i18n_t(`NiotaClassic.Originators.form.types.${curType}.text`)) + "\n            ")])];
        }
      }], null, true)
    })], 1);
  }), 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };